import { render } from "./AppAccordion.vue?vue&type=template&id=20f89a11&scoped=true"
import script from "./AppAccordion.vue?vue&type=script&lang=js"
export * from "./AppAccordion.vue?vue&type=script&lang=js"

import "./AppAccordion.vue?vue&type=style&index=0&id=20f89a11&lang=scss&scoped=true"

import exportComponent from "/home/www-kvs/public_html/resources/frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20f89a11"]])

export default __exports__